import { FIXED_INDENTS } from 'vars/index'

export const TooltipPosition = {
  Top: 'Top',
  Right: 'Right',
  Bottom: 'Bottom',
  Left: 'Left',
} as const
export type TooltipPosition =
  (typeof TooltipPosition)[keyof typeof TooltipPosition]

export const TooltipArrowAlign = {
  TopLeft: 'TopLeft',
  Top: 'Top',
  TopRight: 'TopRight',
  RightTop: 'RightTop',
  Right: 'Right',
  RightBottom: 'RightBottom',
  BottomRight: 'BottomRight',
  Bottom: 'Bottom',
  BottomLeft: 'BottomLeft',
  LeftBottom: 'LeftBottom',
  Left: 'Left',
  LeftTop: 'LeftTop',
} as const
export type TooltipArrowAlign =
  (typeof TooltipArrowAlign)[keyof typeof TooltipArrowAlign]

export const TooltipPaddings = {
  SIZE_0: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  SIZE_10: [FIXED_INDENTS.INDENT_20, FIXED_INDENTS.INDENT_30],
}
export type TooltipPadding =
  (typeof TooltipPaddings)[keyof typeof TooltipPaddings]

export const TooltipMargins = {
  SIZE_0: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  SIZE_10: [
    FIXED_INDENTS.INDENT_30,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
}
export type TooltipMargin = (typeof TooltipMargins)[keyof typeof TooltipMargins]
